
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.252 10c0 .283-.025.55-.058.817l1.758 1.375c.159.125.2.35.1.533l-1.666 2.883a.413.413 0 01-.359.209.47.47 0 01-.15-.025l-2.075-.834c-.433.325-.9.609-1.408.817l-.317 2.208c-.025.2-.2.35-.408.35H8.336a.406.406 0 01-.409-.35l-.316-2.208a6.092 6.092 0 01-1.409-.817l-2.075.834a.416.416 0 01-.508-.183l-1.667-2.884a.42.42 0 01.1-.533l1.759-1.375A6.607 6.607 0 013.752 10c0-.275.025-.55.059-.817L2.052 7.808a.41.41 0 01-.1-.533L3.62 4.392a.413.413 0 01.358-.209c.05 0 .1.009.15.025l2.075.834c.434-.325.9-.609 1.409-.817l.316-2.208c.025-.2.2-.35.409-.35h3.333c.208 0 .383.15.408.35l.317 2.208c.508.208.975.483 1.408.817l2.075-.834a.416.416 0 01.508.183l1.667 2.884a.42.42 0 01-.1.533l-1.758 1.375a6.5 6.5 0 01.058.817zm-1.666 0c0-.175-.009-.35-.042-.608l-.117-.942.742-.583.892-.709-.584-1.008-1.058.425-.883.358-.759-.583a4.728 4.728 0 00-1.025-.592L10.87 5.4l-.133-.942-.159-1.125H9.42l-.167 1.125-.133.942-.883.358a4.88 4.88 0 00-1.042.609l-.75.566-.867-.35-1.058-.425-.583 1.009.9.7.741.583-.116.942c-.025.25-.042.441-.042.608 0 .167.017.358.042.617l.116.941-.741.584-.9.7.583 1.008 1.058-.425.884-.358.758.583c.333.25.667.442 1.025.592l.883.358.134.942.158 1.125h1.167l.166-1.125.134-.942.883-.358a4.877 4.877 0 001.042-.609l.75-.566.866.35 1.059.425.583-1.009-.9-.7-.742-.583.117-.942a6.2 6.2 0 00.042-.608zm-4.584-3.333a3.332 3.332 0 100 6.666A3.332 3.332 0 0013.336 10a3.332 3.332 0 00-3.334-3.333zM8.336 10c0 .917.75 1.667 1.666 1.667.917 0 1.667-.75 1.667-1.667s-.75-1.667-1.667-1.667c-.916 0-1.666.75-1.666 1.667z","fill":"#1D3C6F"}})])
          )
        }
      }
    